var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.users.length > 0)?_c(_vm.screen,{tag:"div",attrs:{"userId":_vm.param}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }